import { render, staticRenderFns } from "./DistrictLocationList.vue?vue&type=template&id=7fcf88f1"
import script from "./DistrictLocationList.vue?vue&type=script&lang=js"
export * from "./DistrictLocationList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports